import { createInertiaApp } from "@inertiajs/react"
import { createRoot } from "react-dom/client"
import type { ComponentType } from "react"
import "@/styles/app.css"

// One chunk per page, so FullCalendar, Stripe and the maps load only where they are used.
const pages = import.meta.glob<{ default: ComponentType }>([
  "../pages/**/*.tsx",
  "!../pages/**/*.test.tsx"
])

createInertiaApp({
  // The legacy #loader overlay (GlobalLoader) is the only progress indicator.
  progress: false,
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) throw new Error(`Unknown page ${name}`)
    return page().then((module) => module.default)
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  }
})
